module.exports = __webpack_public_path__ + "img/contacts-2.f38cc12f.svg";